import React from 'react';
import * as styles from './Content.module.css';

type BackgroundVariant =
  | 'default'
  | 'riche'
  | 'wb'
  | 'ozon'
  | 'yandex'
  | 'dark'
  | 'light';
type ContainerVariant = 'sm' | 'md' | 'lg' | 'xl' | 'full';

export default function Content({
  children,
  background = 'default',
  container = 'md',
}: {
  children: React.ReactNode;
  background?: BackgroundVariant;
  container?: ContainerVariant;
}) {
  return (
    <section className={styles[background]}>
      <div className={`${styles.container} ${styles[container]}`}>
        {children}
      </div>
    </section>
  );
}
